import i18n from "../../i18n";

export const LANDING_PAGE_DATA = {
  'fleet-dashboard': i18n.t('Dashboard'),
  'fleet-map': i18n.t('Live map'),
  'fleet-history-map': i18n.t('History')
}

export const INPUT_DATA = [{
  label: i18n.t('User information'),
  inputs: [{
    label: i18n.t('First name'),
    path: 'first_name',
    type: 'text'
  }, {
    label: i18n.t('Last name'),
    path: 'last_name',
    type: 'text'
  }, {
    label: i18n.t('Email address'),
    path: 'email',
    type: 'text'
  }, {
    label: i18n.t('Username'),
    path: 'username',
    type: 'text'
  }, {
    label: i18n.t('Old password'),
    path: 'old_password',
    type: 'password'
  }, {
    label: i18n.t('New password'),
    path: 'new_password',
    type: 'password'
  }, {
    label: i18n.t('New password confirmation'),
    path: 'confirm_password',
    type: 'password'
  }]
}, {
  label: i18n.t('Site preferences'),
  inputs: [{
    label: i18n.t('Landing page'),
    path: 'landing_page',
    type: 'select'
  }, {
    label: i18n.t('Map opens to fullscreen'),
    path: 'map_fullscreen',
    type: 'checkbox'
  }, {
    label: i18n.t('Custom stop limit (in minutes)'),
    path: 'stop_limit',
    type: 'number',
    text: i18n.t('This will define when the vehicle is marked as "stopped". Recommended value is 5 minutes.')
  }, {
    label: i18n.t('Hide stops in history'),
    path: 'hide_stop_history',
    type: 'checkbox'
  }, {
    path: 'map_section'
  }, {
    label: i18n.t('Map cannot be zoomed or dragged'),
    path: 'map_freeze',
    type: 'checkbox'
  }]
}]